var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail"},[_c('h3',[_vm._v(_vm._s(_vm.detail.title))]),_c('h4',[_c('span',[_vm._v("信息来源："+_vm._s(_vm.detail.source))]),_c('span',[_vm._v("信息时间："+_vm._s(_vm.detail.logintime))])]),_c('table',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.detail.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }